module.exports = __webpack_public_path__ + "img/innoway.f9ce7375.jpeg";